import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { useGlobalToast } from '~/common/contexts/globalToast';
import useCanAccessTeams from '../hooks/useCanAccessTeams';

interface TeamsAccessRequiredProps {
  children: React.ReactNode;
}

const TeamsAccessRequired: React.FC<TeamsAccessRequiredProps> = ({
  children
}) => {
  const { t } = useTranslation();
  const { setContents } = useGlobalToast();
  const canAccessTeams = useCanAccessTeams();

  useEffect(() => {
    if (!canAccessTeams) {
      setContents(
        t('Teams needs an {{monitor}} or {{reports}} license', {
          monitor: 'Axe Monitor',
          reports: 'Axe Reports'
        }),
        'caution'
      );
    }
  }, [canAccessTeams]);

  if (!canAccessTeams) {
    return <Redirect to="/" />;
  }

  return <>{children}</>;
};

export default TeamsAccessRequired;
